// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"b4494e3d","86":"b4e6e220","126":"b82028da","261":"ef1c6157","348":"e12058ea","418":"d05d4c45","441":"e2c64621","534":"a94d1dfb","662":"53154e76","847":"e708aa63","869":"ee9307c2","902":"0813a2b7","909":"46713565"}[chunkId] + ".chunk.js";
};